/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EstablishmentsComplianceFormV2 {
  id?: number;
  establishmentId?: number;
  establishmentOperationDate?: string | null;
  headOfficeType?: string | null;
  timeInAddress?: string | null;
  establishmentIntermediation?: boolean | null;
  productsOrServices?: string | null;
  targetAudience?: string | null;
  ticketSize?: string | null;
  siteLink?: string | null;
  exchangePolicies?: boolean | null;
  instagramProfile?: string | null;
  facebookProfile?: string | null;
  linkedinProfile?: string | null;
  otherProfile?: string | null;
  ibansameCountryHeadOffice?: boolean | null;
  justificationIbansameCountryHeadOffice?: string | null;
  clientInfoData?: boolean | null;
  justificationClientInfoData?: string | null;
  checkComercialCapacity?: boolean | null;
  kycProgram?: boolean | null;
  kycProgramInfo?: string | null;
  pldCftProgram?: boolean | null;
  pldCftProgramInfo?: string | null;
  pepPolicies?: boolean | null;
  justificationPepPolicies?: string | null;
  sellToMinors?: boolean | null;
  moneyLaundryTraining?: boolean | null;
  levelOfDueDiligence?: boolean | null;
  justificationLevelOfDueDiligence?: string | null;
  revisionProcess?: boolean | null;
  explanationRevisionProcess?: string | null;
  civilComercialCapacity?: boolean | null;
}
